import { render, staticRenderFns } from "./videosettings.vue?vue&type=template&id=04318b6b"
import script from "./videosettings.vue?vue&type=script&lang=js"
export * from "./videosettings.vue?vue&type=script&lang=js"
import style0 from "./videosettings.vue?vue&type=style&index=0&id=04318b6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports